import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

const CONSENT_KEY = 'cookie_consent_v1';

/**
 * Баннер согласия на обработку cookie и персональных данных (152-ФЗ).
 * Показывается до принятия; выбор хранится в localStorage.
 */
export function CookieConsent() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      if (!localStorage.getItem(CONSENT_KEY)) setVisible(true);
    } catch (_) {
      setVisible(true);
    }
  }, []);

  const accept = () => {
    try {
      localStorage.setItem(CONSENT_KEY, JSON.stringify({ accepted: true, ts: Date.now() }));
    } catch (_) {}
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      className="fixed bottom-0 inset-x-0 z-[100] p-4 sm:p-5"
      role="dialog"
      aria-label="Согласие на использование cookie"
    >
      <div className="mx-auto max-w-3xl rounded-2xl border border-border bg-card/95 backdrop-blur shadow-lg p-4 sm:p-5 flex flex-col sm:flex-row sm:items-center gap-3">
        <p className="text-sm text-muted-foreground flex-1">
          Мы используем cookie и обрабатываем данные, необходимые для работы сервиса. Продолжая
          пользоваться РешAI, вы соглашаетесь с{' '}
          <Link to="/privacy" className="text-primary underline underline-offset-2">
            Политикой конфиденциальности
          </Link>{' '}
          и{' '}
          <Link to="/cookies" className="text-primary underline underline-offset-2">
            использованием cookie
          </Link>
          .
        </p>
        <button
          onClick={accept}
          className="rounded-full px-6 py-2.5 bg-primary text-primary-foreground font-medium text-sm whitespace-nowrap"
          data-testid="cookie-consent-accept"
        >
          Принять
        </button>
      </div>
    </div>
  );
}

export default CookieConsent;
